/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
// import Toast from './sub_components/toast';
import * as authServices from '../services/authService';
import * as accountServices from '../services/accountService'
// import * as utilService from '../services/utilService'
// import Joinnowpopup from './sub_components/joinnowpopup'
// import Loginpopup from './sub_components/loginpopup'
import LoginSportsThumbnailList from './sub_components/loginSportsThumbnailList'
import AboutUs from './sub_components/aboutUs'
import BettingRules from './sub_components/bettingRules'
import DepositsAndWithdrawals from './sub_components/depositsAndWithdrawals'
import PrivacyPolicy from './sub_components/privacyPolicy'
import TermsAndConditions from './sub_components/termsAndConditions'
// import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../configs/const';
import { DOMAINDISPLAY } from '../configs/apkFileName';
// import { ReCAPTCHA_KEY } from '../configs/const';
// import ReCAPTCHA from "react-google-recaptcha";
// import Maintanence from './sub_components/maintanence'
// import * as constants from '../configs/const'
import Loginb2cHeader from './loginb2cHeader';
// import bannerList from 'https://images.staticcontents.com/banners/list.json'


import * as CASINOSHOWLIST from '../configs/casinoShowList';
import moment from 'moment';
import { getNotification } from '../services/notificationservice';
let oid = OPERATOR_ID.toLowerCase()
// const recaptchaRef = React.createRef();
const hostname = window && window.location && window.location.hostname;

class NewMobileFooter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clientWidth: document.documentElement.clientWidth,
            notificationCount: 0,
        };
    }
    
    componentDidMount() {
        let prfdt = localStorage.getItem('profData');
        if(!!prfdt){
            prfdt = JSON.parse(prfdt);
        }
        if (!!prfdt && prfdt.role !== 'DemoClient') {
            if(this.state.clientWidth <= 768) {
                this.getNotifications();
            }
        }
    }
    
    getNotifications() {
        const data = `fromDate=${moment().subtract(1, 'day').startOf('day').toISOString()}&toDate=${moment().add(1, 'day').endOf('day').toISOString()}`;
        getNotification(data).then((res) => {
            if (res && res.isSuccess === true) {
                this.setState({ notificationCount: res.items.length });
            }
        });
    }

    checkViewSelection(view) {
        let rtnval = '';
        if (view === 'home') {
            if (window.location.pathname === '/' || ["auth", "affiliate", "apk", "home"].includes(window.location.pathname.split('/')[1])) {
                rtnval = 'active';
            }
        } else if (view === 'inplay' && window.location.pathname === '/inplay') {
            rtnval = 'active';
        } else if (view === 'notification' && window.location.pathname === '/notifications') {
            rtnval = 'active';
        }

        return rtnval;
    }

    onMenuClick() {
        const accData = JSON.parse(localStorage.getItem("accountData"));
        if (!!accData && Object.keys(accData).length > 0) {
            document.getElementById('btnExpoRightMenu').click();
        } else {
            document.getElementById('btnLoginb2cLogin').click();
        }
    }

    onOpenGameClick() {
        const accData = JSON.parse(localStorage.getItem("accountData"));
        if (!!accData && Object.keys(accData).length > 0) {
            this.props.setOpenGame(true);
        } else {
            document.getElementById('btnLoginb2cLogin').click();
        }
    }

    increaseNotificationCount() {
        this.setState({ notificationCount: this.state.notificationCount + 1 });
    }
    render() {
        const accData = JSON.parse(localStorage.getItem("accountData"));
        const profData = JSON.parse(localStorage.getItem("profData"));
        return (
            <>

                <div className='footer-menu '>
                    <div className="wrapper">
                        <div className={`button-f ${this.checkViewSelection('home')}`} onClick={() => this.props.history.push("/home")}>
                            <div className="icon">

                                <img src={BASE_IMAGE_PATH + "/" + oid + "/uimg/home.svg"} alt={""}></img>

                            </div>
                            <span>Home</span>
                        </div>
                        <div className={`button-f ${this.checkViewSelection('inplay')}`} onClick={() => this.props.history.push("/inplay")}>
                            <div className="icon">

                                <img src={BASE_IMAGE_PATH + "/" + oid + "/uimg/inplay.svg"} alt={""}></img>

                            </div>
                            <span>Inplay</span>
                        </div>
                        {!!accData && Object.keys(accData).length > 0  && profData.role != "DemoClient" &&
                        <div className={`button-f f-notification ${this.checkViewSelection('notification')}`} onClick={() => this.props.history.push("/notifications")}>
                            <div className="icon Notification-footer">

                                <i className="ml-2 fa fa-bell text-white notification-mobile-icon"></i>
                                <div className="badge">{this.state.notificationCount}</div>

                            </div>
                            <span>Notification</span>
                        </div>
                        }
                        {(CASINOSHOWLIST.casinoList['INDIANPOKER'].show) &&
                            <div className="button-f" onClick={() => this.onOpenGameClick()}>
                                <div className="icon">

                                    <img src={BASE_IMAGE_PATH + "/" + oid + "/uimg/mini_games.gif"} alt={""}></img>

                                </div>
                                <span>MiniGame</span>
                            </div>
                        }
                        <div className="button-f" onClick={() => this.onMenuClick()}>
                            <div className="icon">

                                <img src={BASE_IMAGE_PATH + "/" + oid + "/uimg/menu.svg"} alt={""}></img>

                            </div>
                            <span>Menu</span>
                        </div>
                    </div>
                    {/* <ul className='footer-fixed-menu'>
                        <li>12</li>
                        <li>12</li>
                        <li>12</li>
                        <li>12</li>
                    </ul> */}
                </div>
                <i id='iIncreaseNotificationCount' className='d-none' onClick={()=>this.increaseNotificationCount()}></i>

            </>)
    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(NewMobileFooter);